import React from 'react';

const Nebraska = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Nebraska Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Disclosure required on or before the purchase contract is signed.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Nebraska-Seller-Property-Condition-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            Seller's Property Condition Disclosure Statement{' '}
          </span>{' '}
          – Buyers must be given a written statement describing the property's
          condition before the purchase agreement becomes effective.
        </li>
      </ol>
    </div>
  );
};

export default Nebraska;
